// Holder rede på skjemaer med tekst som ikke er lagret, så app-oppdateringen
// kan vente til brukeren er ferdig (PRD US21). Sporingen er generell: et
// skjema regnes som ulagret fra første tastetrykk til det sendes inn eller
// forsvinner fra siden. Felt utenfor et <form> (f.eks. notatfelt) spores for
// seg og regnes som ulagret så lenge de har innhold og står på siden.

const dirty = new Set<Element>();
let started = false;

const hasContent = (el: Element) =>
  el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement
    ? el.value.trim() !== ""
    : (el.textContent ?? "").trim() !== "";

const onInput = (event: Event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  // Søkefelt og filtre er ikke «tekst man mister».
  if (target instanceof HTMLInputElement && target.type === "search") return;
  if (target.closest("[data-unsaved-ignore]")) return;
  const form = target.closest("form");
  if (form) {
    dirty.add(form);
    return;
  }
  const editable =
    target.closest("[contenteditable='true']") ??
    (target instanceof HTMLTextAreaElement ? target : null);
  if (editable) dirty.add(editable);
};

const onSubmit = (event: Event) => {
  if (event.target instanceof Element) dirty.delete(event.target);
};

export const startUnsavedInputTracking = () => {
  if (started || typeof document === "undefined") return;
  started = true;
  document.addEventListener("input", onInput, true);
  document.addEventListener("submit", onSubmit, true);
  document.addEventListener("reset", onSubmit, true);
};

export const hasUnsavedInput = () => {
  for (const el of [...dirty]) {
    const gone = !el.isConnected;
    const emptied = el.tagName !== "FORM" && !hasContent(el);
    if (gone || emptied) dirty.delete(el);
  }
  return dirty.size > 0;
};
